export enum FilterType {
  Category = 'CategoryFilter',
  ChartRange = 'ChartRangeFilter',
  DateRange = 'DateRangeFilter',
  NumberRange = 'NumberRangeFilter',
  String = 'StringFilter'
}
